import * as React from 'react';
import './AccountMonthlyStatement.scss';
import MonthlyStatementModel from 'src/model/monthlyStatement.model';
import AccountInfoHeader from '../AccountInfoHeader';
import AccountStatementFooter from './components/AccountStatementFooter';
import ToolBar from './components/ToolBar';
import SelectAgeBar from './components/SelectAgeBar';
import CurrentStatementUsa from './components/CurrentStatementInfo/Usa';
import TotalTable from './components/TotalTable';
import StatementTable from './components/StatementTable';
import AccountSummary from './components/AccountSummary';
import TablePaginator from 'src/components/common/TablePagination';

export interface IAccountStatementProps {
  monthlyStatementContent: MonthlyStatementModel;
  getMonthlyStatement(page: number, period: number, size: number): void;
}

export interface IAccountStatementState {
  selectedMonth: number;
  pageNumber: number;
}

class AccountStatement extends React.Component<
  IAccountStatementProps,
  IAccountStatementState
> {
  constructor(props: IAccountStatementProps) {
    super(props);
    this.state = { selectedMonth: 1, pageNumber: 0 };
  }

  private handleStatementOptionChange = (option: number) => {
    this.setState({ selectedMonth: option });
  };

  private handlePagination = (type: 'next' | 'previous') => {
    const pagination = this.props.monthlyStatementContent.statementDetails;
    if (type === 'previous') {
      if (pagination.pageNumber !== 0) {
        this.setState({ pageNumber: pagination.pageNumber - 1 }, () => {
          this.props.getMonthlyStatement(
            this.state.pageNumber,
            this.state.selectedMonth,
            null
          );
        });
      }
    } else {
      if (pagination.pageNumber !== pagination.totalPages) {
        this.setState({ pageNumber: pagination.pageNumber + 1 }, () => {
          this.props.getMonthlyStatement(
            this.state.pageNumber,
            this.state.selectedMonth,
            null
          );
        });
      }
    }
  };

  private handleDesktopPagination = (pageNumber: number) => {
    this.setState({ pageNumber: pageNumber - 1 }, () => {
      this.props.getMonthlyStatement(
        this.state.pageNumber,
        this.state.selectedMonth,
        this.props?.monthlyStatementContent?.statementDetails?.pageSize
      );
    });
  };

  private handlePageSizeChange = (pageSize: number) => {
    this.setState({ pageNumber: 0 }, () => {
      this.props.getMonthlyStatement(0, this.state.selectedMonth, pageSize);
    });
  };

  public componentDidMount() {
    this.props.getMonthlyStatement(0, 1, 20);
  }

  public render() {
    const { monthlyStatementContent: stmentCont } = this.props;
    return (
      <div className="rp-accountcard">
        <AccountInfoHeader />
        <ToolBar currentMonth={this.state.selectedMonth} />
        <SelectAgeBar
          selectedOption={this.state.selectedMonth}
          handleOptionChange={this.handleStatementOptionChange}
        />
        <CurrentStatementUsa
          addressLineOne={stmentCont.addressLineOne}
          addressLineTwo={stmentCont.addressLineTwo}
          addressLineThree={stmentCont.addressLineThree}
          addressLineFour={stmentCont.addressLineFour}
          statementDate={stmentCont.statementDate}
          customerNumber={stmentCont.customerNumber}
        />
        <StatementTable
          data={stmentCont?.statementDetails?.data}
          pagination={stmentCont.statementDetails}
          handlePageSizeChange={this.handlePageSizeChange}
          handleDesktopPagination={this.handleDesktopPagination}
        />
        <TotalTable
          total={stmentCont.total}
          current={stmentCont.currentTotal}
          pastDue1={stmentCont.oneMonthPastTotal}
          pastDue31={stmentCont.twoMonthsPastTotal}
          pastDue61={stmentCont.threeMonthsPastTotal}
        />
        <div className="rp-product-statments-mobile-paginator">
          <TablePaginator
            handlePagination={this.handlePagination}
            pagination={{
              pageNumber: stmentCont.statementDetails.pageNumber,
              pageSize: stmentCont.statementDetails.pageSize,
              totalPages: stmentCont.statementDetails.totalPages
            }}
          />
        </div>
        <AccountSummary
          beginningBalance={stmentCont.beginningBalance}
          payments={stmentCont.payments}
          adjustments={stmentCont.adjustments}
          chargesCredits={stmentCont.chargesOrCredits}
          endingBalance={stmentCont.endingBalance}
        />
        <AccountStatementFooter />
      </div>
    );
  }
}

export default AccountStatement;
